import {
  clearSrDocumentDocTypeAction,
  clearSrDocumentDocTypeErrors,
  createSrDocumentDocType,
} from 'actions/srDocuments/srDocumentDocTypeActions'
import AdminForm from 'components/admin/AdminForm'
import _ from 'lodash'
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

const SrDocumentDocTypeCreate = ({ formId, params, setParams, closeModal }) => {
  //// HOOKS.
  const dispatch = useDispatch()

  //// GLOBAL STATE.
  const { lastAction, docTypeErrors } = useSelector(
    (state) => state.srDocumentDocTypes
  )

  //// LOCAL STATE.

  //// LIFECYCLE HELPERS.

  //// MEMOS.

  //// EFFECTS.
  useEffect(() => {
    return () => {
      dispatch(clearSrDocumentDocTypeErrors())
      dispatch(clearSrDocumentDocTypeAction())
    }
  }, [dispatch])

  useEffect(() => {
    if (_.isEmpty(params)) {
      setParams({
        name: '',
      })
    }
  }, [params, setParams])

  useEffect(() => {
    if (lastAction === 'create') {
      closeModal()
    }
  }, [lastAction, closeModal])

  //// RENDER VARS & HELPERS.

  //// RENDER.
  return !_.size(params) ? (
    ''
  ) : (
    <form
      id={formId}
      onSubmit={(e) => {
        e.preventDefault()

        dispatch(createSrDocumentDocType(params))
      }}
      className="form container"
      noValidate
    >
      <AdminForm params={params} setParams={setParams} errors={docTypeErrors} />
    </form>
  )
}

export default SrDocumentDocTypeCreate
